import React from 'react';
import AddFormProto from "app/quick-add/sections/project/form/new-project-form-proto.tsx";

import Form from '../../../../../../core/gd-form/form/deprecated/form-add/form-add';
import FormManager from 'src/core/gd-form/common/form-manager';

import Api from '../../../../../../core/gd/api/api';
import NewProject_StartDateSelector from "../components/start-date/start-date";
import {newProject_getFormFieldsProto} from "app/quick-add/sections/project/form/common";

class ComponentName extends AddFormProto {

    constructor(props) {
        super(props,  gd.const.project.type.PROJECT);

        this._bind('onSubmit');


        const { template } = this.props;

        // init tpl copy options
        this.initCopyOptions = [];
        if (template.templateContent) {
            const { events, subProjects, tasks } = template.templateContent;
            if (events)         this.initCopyOptions.push("events");
            if (subProjects)    this.initCopyOptions.push("subProjects");
            if (tasks)          this.initCopyOptions.push("tasks");
        }

        // FORM
        const initFormData = {
            company             : gd.companyId,
            parentProject       : this.initProjectId,
            name                : '',
            owner               : gd.session.me.id,

            color               : this.defaultColor,
            defaultView         : template.defaultView,

            deadline            : null,
            copyOptions         : this.initCopyOptions,

            startDate           : moment(),
        };


        const formStructure = {
            fields: _.merge(newProject_getFormFieldsProto(this), {

                deadline: {
                    type: 'select',
                    isRequired: false,
                    label: 'Deadline'
                },

                startDate: {
                    type: 'select',
                    label: 'Start date',
                    isRequired: false,
                    validator: (value,formManager)=>{
                        //  && formManager.fields.endDate - because we validate startDate before init endDate
                        if (value && formManager.fields.endDate) {
                            formManager.validateField('endDate');
                        }
                        return true;
                    }
                }
            }),
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);

    }

    onSubmit(result) {

        const { copyOptions } = result;

        const newProjectData = {

            toCompanyId: result.company,
            toProjectId: result.parentProject,

            templateId: this.props.template.id,
            wipeTemplateContent: false, //!!this.props.template.wipeTemplateContent,
            name: result.name,
            // prefix: result.prefix,

            color: result.color,
            defaultView: result.defaultView,
            ownerUserId: result.owner,
            deadline: result.deadline,

            copyTasks:          copyOptions.includes("tasks"),
            copySubProjects:    copyOptions.includes("subProjects"),
            copyEvents:         copyOptions.includes("events"),

            planningStartDate       : result.startDate?.format("YYYY-MM-DD")
        };

        const request = Api.Project.newProjectFromTemplate(newProjectData);

        request.done((data)=>{
            this.onProjectCreated(data);
        });
    }

    render() {
        const { advanced } = this.state;

        return (
            <Form form={this.form} submitBtnClass="grey">


                {this.renderAdvancedSwitch()}

                <div className="tbl">

                    {this.renderSelectParent()}

                    {this.renderNameAndColor()}

                    {this.renderDeadline()}

                    {advanced && this.renderOwner()}

                    {/*{advanced && this.renderDefaultView()}*/}

                    {advanced && this.renderTemplateCopyOptions()}
                    {advanced &&
                        <NewProject_StartDateSelector form={this.form} />
                    }

                </div>

            </Form>
        );

    }

}

module.exports = ComponentName;
